import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link } from 'react-router-dom';
import ColorBox from '../ColorBox';
import STLViewer from '../Canvas/STLViewer';
import SimpleSTLViewer from '../Canvas/SimpleStlViews';
import FormatDateString from '../dateFormat';
import validateError from '../../ValidateError';
import vAdminformat from '../../adminFormat';
import STLViewerQuot from '../Canvas/STLViewerQuot';

const server_backend = config.API_URL;

function UpdateOrder({ username, onOrderID, onClose, getOrders }) {
    const [loading, setLoading] = useState(false);
    const [userCreated, setUserCreated] = useState("");
    const [userModify, setUserModify] = useState("");
    const [dateCreated, setDateCreated] = useState("");
    const [dateModify, setDateModify] = useState("");
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    //Test
    const [showDropdown, setShowDropdown] = useState(false);
    const [STLfileBussiness, setSTLFileBussiness] = useState(null);
    const [customerFiles, setCustomerFile] = useState([]);
    const [fileURL, setFileURL] = useState("");
    const [materialList, setMaterialList] = useState([]);
    const [selectedMaterialColor, setSelectedMaterialColor] = useState('#FFFFFF');
    const [selectedMaterial, setSelectedMaterial] = useState(null);

    const [fileUploadList, setFileUploadlist] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [currentDencity, setCurrentDencity] = useState(0);
    const [materialPrice, setMaterialPrice] = useState([]);
    const [currentPrice, setCurrentPrice] = useState(0);
    const [ConfUpload, setConfUpload] = useState(false);
    const [getBussinessFiles, setGetBussinessFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0); //Now we just need general progress
    const [isUpdateJob, setIsUpdateJob] = useState(0);
    const [statusQuot, setStatusQuot] = useState([]);
    const [isPrivate, setIsPrivate] = useState(0);
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentCustomer, setCurrentCustomer] = useState(0);
    const [nanito, setNanito] = useState(false);

    const [formData, setFormData] = useState({
        id: onOrderID,
        name: "",
        lastname: "",
        mat_id: 1,
        file_id: "",
        date_estimated: '',
        email: "",
        phone: "",
        phone2: "",
        address: "",
        city: "",
        zipcode: "",
        country: "",
        shipping_address: "",
        shipping_city: "",
        shipping_zipcode: "",
        shipping_country: "",
        contact_fullname: "",
        contact_phone: "",
        contact_email: "",
        comment: "",
        qty: 1,
        items: [],
        volume: "",
        discount: 0,
        area: "",
        weight: "",
        dimensions: "",
        job_comment: "",
        reference1: "",
        reference2: "",
        quotj_ID: "",
        est_id: ""
    });

    const CHUNK_SIZE = 10240 * 10240;

    useEffect(() => {
        const fetchOrder = async () => {
            setLoading(true)
            try {
                const response = await axios.get(`${server_backend}/Orders/select?id=${onOrderID}`, headers);
                if (response.data.RES_CODE === "00") {
                    const data = response.data.RES_RESULT;
                    console.log(response.data)
                    setUserCreated(data.user_created);
                    setUserModify(data.user_modify);
                    setDateCreated(data.date_created);
                    setDateModify(data.date_modify);
                    setFormData({
                        ...data,
                        qty: 1,
                        est_id: data.est_ID,
                        date_estimated: data.date_estimated
                    });
                    setCurrentCustomer(data.cust_ID)

                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false)
            }
        };
        fetchOrder();
    }, [onOrderID, username]);

    useEffect(() => {
        const getBussinessLibrary = async () => {

            try {
                const response = await axios.get(`${server_backend}/files/private/list?user_transaction=${username}`, headers);
                if (response.data.RES_CODE === "00") {

                    setGetBussinessFiles(response.data.RES_RESULT.sort((a, b) => {

                        return b.file_ID - a.file_ID;


                    }));
                }
            } catch (error) {
                console.log(error)
            }
        }
        getBussinessLibrary();
    }, []);

    const handleUploadFileModal = async () => {
        if (selectedFiles.length === 0) return;

        setIsUploading(true); //We show the progress bar
        const file = selectedFiles[0]; //We only upload the first file for now
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
            const start = chunkIndex * CHUNK_SIZE;
            const end = Math.min(start + CHUNK_SIZE, file.size);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append('chunk', chunk);
            formData.append('chunkIndex', chunkIndex);
            formData.append('totalChunks', totalChunks);
            formData.append('name', file.name);
            formData.append('user_transaction', username);

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': headers.headers.Authorization,
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((chunkIndex + 1) / totalChunks * 100);
                    setUploadProgress(percentCompleted);
                }
            };

            try {
                const response = await axios.post(`${server_backend}/files/private/insert`, formData, config);


                if (response.data.RES_CODE == "00") {
                    //getCustomer();
                    setConfUpload(true);
                    setIsUploading(false);
                    setUploadProgress(0);
                    return;
                }
            } catch (error) {
                //console.error('Error uploading file:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'There is a file with the same name',
                    showConfirmButton: false,
                    timer: 2000
                });
                setIsUploading(false);
                setUploadProgress(0);
                return;
            }
        }

        setIsUploading(false);
        setUploadProgress(0);
    };

    const fetchOrder = async () => {
        try {
            const response = await axios.get(`${server_backend}/Orders/select?id=${onOrderID}`, headers);
            if (response.data.RES_CODE === "00") {
                const data = response.data.RES_RESULT;
                //console.log(response.data)
                setUserCreated(data.user_created);
                setUserModify(data.user_modify);
                setDateCreated(data.date_created);
                setDateModify(data.date_modify);

                setFormData({
                    ...data,
                    qty: 1,
                    est_id: data.est_ID,
                    date_estimated: data.date_estimated
                });

                setCurrentCustomer(data.cust_ID)

            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        //at the end (TRUE);

        //Console.log ({Order: FormData, Estatus: Formdata.est_id});

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/Orders/update`, {
                        ...formData,
                        id: onOrderID,
                        est_id: formData.est_id
                    }, headers);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Updated Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        onClose();
                        getOrders();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error updating Order',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    const responseData = error.response.data.RES_MESSAGE;
                    //console.log(error)
                    Swal.fire({
                        icon: 'error',
                        title: responseData,
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            }
        }
        )
    };

    const handleFileSelect = (File) => {
        console.log({ File: File })
        setSTLFileBussiness(File);
        setFileURL(File.path_File);
        setIsDropdownVisible(false);
    };

    const formatStats = (stats) => {
        const formatNumber = (num, decimals) => num.toFixed(decimals);
        console.log("thi is format stats")
        const volume = formatNumber(stats.volume / 1000, 2);
        const area = formatNumber(stats.area / 100, 2);
        const weight = formatNumber(stats.weight / 1000, 2);

        const dimensions = {
            x: formatNumber(stats.dimensions.x / 10, 2),
            y: formatNumber(stats.dimensions.y / 10, 2),
            z: formatNumber(stats.dimensions.z / 10, 2)
        };

        stats.volume = volume;
        stats.area = area;
        stats.weight = weight;
        stats.file_id = STLfileBussiness.file_ID;
        stats.dimensions = `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`;
        //setFormData({volume: ...volume});
        return stats;

        /*return {
            volume: `${volume} cm³`,
            area: `${area} cm²`,
            weight: `${weight} g`,
            dimensions: `${dimensions.x} x ${dimensions.y} x ${dimensions.z} cm`
        }; */
    };

    const handleStatsUpdate = (stats) => {
        const formattedStats = formatStats(stats);
        //console.log(stats)
        setFormData(formattedStats);
    };

    const handleMaterialSelect = (material) => {
        setSelectedMaterial(material);
        setFormData({ ...formData, mat_id: material.mat_ID });
        setShowDropdown(false);
    };

    useEffect(() => {
        const getMaterial = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/list`, headers);
                if (response.data.RES_CODE === "00") {
                    setMaterialList(response.data.RES_RESULT);
                    setFormData((prevData) => ({
                        ...prevData,
                        mat_id: response.data.RES_RESULT[0].mat_ID,
                    }));
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (isUpdateJob === 0) {  //It is with the objective of selecting the
            //first material when adding a new object
            getMaterial();
        }
    }, [isUpdateJob]);

    useEffect(() => {
        const getCustomer = async () => {
            try {
                const response = await axios.get(`${server_backend}/customers/files/list?id=${currentCustomer}`, headers);
                if (response.data.RES_CODE === "00") {
                    //console.log({ eo: response.data });
                    const data = (response.data.RES_RESULT)
                    setCustomerFile(data)
                }
            } catch (error) {
                console.log({ bobocliente: error })
            }
        }
        getCustomer();
    }, [currentCustomer]);

    /*const getCurrentFile = async (fileID) => {
         console.log({ fileID: fileID });
         try {
             const response = await axios.get(`${server_backend}/customers/files/list?id=${fileID}`, headers);
             if (response.data.RES_CODE === "00") {
                 const data = (response.data.RES_RESULT);
                 console.log({data: data});
                
                 setIsDropdownVisible(false);
             }
         } catch (error) {
console.log(error)
         }
     } */

    useEffect(() => {

        const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

        if (selectedMaterial) {
            setSelectedMaterial(selectedMaterial);
            setSelectedMaterialColor(selectedMaterial.color);
        }
    }, [STLfileBussiness, !isUpdateJob]);

    useEffect(() => {
        const getMaterialPrice = async () => {
            try {
                const response = await axios.get(`${server_backend}/materials/types/list`, headers);
                //console.log({ eo: response.data });

                if (response.data.RES_CODE === "00") {
                    setMaterialPrice(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error)
            }
        }
        getMaterialPrice();
    }, []);

    useEffect(() => {
        if (selectedMaterial) {

            const vw = formData.weight * selectedMaterial.density;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);
            if (isUpdateJob === 0) {
                setCurrentPrice(price);
            }
        }
    }, [selectedMaterial, formData.weight, !isUpdateJob]);

    useEffect(() => {
        const getStatusOrder = async () => {
            try {
                const response = await axios.get(`${server_backend}/system/transactions/status/Order`, headers);
                if (response.data.RES_CODE === "00") {
                    setStatusQuot(response.data.RES_RESULT);
                }
            } catch (error) {
                console.log(error);
            }
        }
        getStatusOrder();
    }, []);

    //These two hooks are used to correctly select the first material once the corresponding variables have been updated.
    useEffect(() => {
        if (materialList && materialList.length > 0 && formData.mat_id && !isInitialized) {
            const selectedMaterial = materialList.find(material => material.mat_ID === formData.mat_id);

            if (selectedMaterial) {
                handleMaterialSelect(selectedMaterial);
                setSelectedMaterialColor(selectedMaterial.color);
                setCurrentDencity(selectedMaterial.density);

                setIsInitialized(false);
            }
        }
    }, [materialList, formData.mat_id, isInitialized, formData.qty, !isUpdateJob]); //Dependence in format.mat_id

    useEffect(() => {
        if (isInitialized && selectedMaterial) {
            const vw = formData.weight * selectedMaterial.density;
            const price = calculatePrice(selectedMaterial.formula, vw, materialPrice);
            if (isUpdateJob === 0) {
                setCurrentPrice(price);
            }
        }
    }, [formData, materialPrice, selectedMaterial, isInitialized, !isUpdateJob]);
    //end


    const closeModalFile = () => {
        //setSTLFileBussiness(null)
        cleanSTLFiles()
        setFileUploadlist(false)

    }

    const openModalFile = (item, firstFile) => {
        //console.log({ item: item })

        if (firstFile === true) {

            setIsUpdateJob(0);
            setFileUploadlist(true)

        } else if (firstFile === false) {

            const papotico = true;
            setNanito(papotico);
            setIsUpdateJob(1);
            setSTLFileBussiness({
                ...item,
                name: item.file_name
            });
            setFileURL(`${server_backend}/${item.files_path_file}`);
            //handleEdit(index)

            setFileUploadlist(true);
            console.log({ item: item });
            setFormData({
                ...formData,
                file_id: item.file_ID,
                parts: item.parts,
                date_estimated: item.date_estimated,
                price: item.price,
                qty: item.qty,
                job_comment: item.comment,
                volume: item.volume,
                comment: item.comment,
                discount: item.discount,
                area: item.area,
                dimensions: item.dimensions,
                mat_id: item.mat_ID,
                weight: item.weight,
                quotj_ID: item.quotj_ID,
                ordj_ID: item.ordj_ID
            });
            setCurrentPrice(item.price);
        }

    }

    const calculatePrice = (formula, formDataWeight, materialPrice) => {
        //Console.log ({Formula: Formula, FormDataWeight: FormDataWeight, MaterialPrice: MaterialPrice});


        if (!formula || formula.trim() === '') {
            return null;
        }

        let processedFormula = formula.replace(/{weight}/g, formDataWeight);

        materialPrice.forEach((material) => {
            const variableName = material.variable.replace(/[{}]/g, '');
            processedFormula = processedFormula.replace(new RegExp(`{${variableName}}`, 'g'), material.lastprice);
        });
        //console.log({ formula: formula, processedFormula: processedFormula })
        try {

            const price = eval(processedFormula);
            return parseFloat(price).toFixed(2);
        } catch (error) {
            console.error("Error calculating price:", error);
            return null;
        }
    };

    const UpdateFileToItems = async () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                const newItem = {
                    volume: formData.volume,
                    area: formData.area,
                    parts: formData.parts || 1,
                    date_estimated: formData.date_estimated || new Date().toISOString().slice(0, 16),
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: STLfileBussiness.file_ID,
                    qty: formData.qty,
                    discount: formData.discount,
                    mat_id: formData.mat_id,
                    ord_id: onOrderID,
                    price: currentPrice,
                    mount: currentPrice,
                    file_name: STLfileBussiness.name,
                    materialname: selectedMaterial.name,
                    id: formData.ordj_ID //Be sure to include the Job ID
                };
                console.log(newItem)

                try {
                    const response = await axios.post(`${server_backend}/Orders/jobs/update`, newItem, headers);
                    console.log(response.data)
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Update Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        fetchOrder()
                        //Clean the fields
                        setFileUploadlist(false);
                        cleanSTLFiles()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                }


            }

        }
        )


    };

    function cleanSTLFiles() {
        setSelectedMaterial(null);
        setSTLFileBussiness([]);
        setSelectedFiles([]);
        setFormData((prevState) => ({
            ...prevState,
            qty: 1,
            price: 0,
            mat_id: ''
        }))
        //closeModalFile();
    }

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setSTLFileBussiness(selectedFile);
        const files = Array.from(event.target.files);
        setSelectedFiles(files);

        const url = URL.createObjectURL(selectedFile);
        setFileURL(url);
    };

    //handles the decrease in quantity
    const handleDecreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: Math.max(prevState.qty > 1 ? prevState.qty - 1 : 1)
        }));
    };

    //handle the quantity increase
    const handleIncreaseQuantity = () => {
        setFormData(prevState => ({
            ...prevState,
            qty: prevState.qty ? prevState.qty + 1 : 1
        }));
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;

        //Allows only numbers and a decimal point
        const cleanValue = value.replace(/[^0-9.]/g, '');

        //Verify that there is no more than a decimal point
        if ((cleanValue.match(/\./g) || []).length <= 1) {
            //Update the state without even parse to allow the point in real time
            setCurrentPrice(cleanValue);
        }
    };

    //Calculate the total sub from formdata.jobs
    const calculateSubTotal = () => {
        if (formData.jobs && formData.jobs.length > 0) {
            return formData.jobs.reduce((acc, item) => acc + (item.price * item.qty), 0);
        }
        return 0;
    };

    const createJobs = () => {

        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this transaction?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                const newItem = {
                    id: onOrderID,
                    volume: formData.volume,
                    area: formData.area,
                    weight: formData.weight,
                    dimensions: formData.dimensions,
                    job_comment: formData.job_comment,
                    file_id: formData.file_id,
                    mat_id: selectedMaterial.mat_ID,
                    price: currentPrice,
                    qty: formData.qty,
                    mount: currentPrice,
                    filename: STLfileBussiness.name,
                    materialname: selectedMaterial.name,
                    discount: formData.discount,
                    file_private: isPrivate,
                    urlfile: fileURL
                };
                console.log({ Items: newItem });
                try {
                    const response = await axios.post(`${server_backend}/Orders/jobs/insert`, newItem, headers);
                    console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Created Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        cleanSTLFiles()
                        fetchOrder()
                        setFileUploadlist(false)
                        setLoading(false);

                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    fetchOrder() //update Order select
                }
            }
        }
        )



    };

    const deleteJob = async (jobID) => {
        console.log({ jobID: jobID })
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to delete this job? This action cannot be undone.",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {

                try {
                    const response = await axios.post(`${server_backend}/Orders/jobs/delete`, {
                        id: jobID
                    }, headers);
                    console.log(response.data);
                    if (response.data.RES_CODE === "00") {
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted Successfully',
                            showConfirmButton: false,
                            timer: 1000
                        });

                        fetchOrder()
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'An error occurred, please try again.',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
                } catch (error) {
                    console.log(error)
                    const message = validateError(error);

                    Swal.fire({
                        icon: 'error',
                        title: message,
                        showConfirmButton: false,
                        timer: 2000
                    });
                } finally {
                    setLoading(false);
                    fetchOrder() //update Order select
                }
            }
        }
        )

    };



    return (
        <div className="row">
            <div className="card">
                <div className="card-header align-items-center d-flex">
                    <div className="col-12">
                        <div className="row">
                            <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {

                                    Swal.fire({
                                        icon: 'warning',
                                        title: 'Alert',
                                        text: "Are you sure you want to discard these changes?",
                                        showCancelButton: true,
                                        confirmButtonText: 'Accept',
                                        cancelButtonText: "Cancel"
                                    }).then(async (result) => {
                                        if (result.isConfirmed) {
                                            onClose();
                                        }
                                    }
                                    )
                                }
                                }>Discard Change</Link>
                                <button type="button" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                            </div>

                            <center><h5>Order ID: <Link>{onOrderID}</Link></h5></center>
                        </div>
                    </div>

                </div>
                <div className="modal-body">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header border-bottom-dashed p-4">
                                    <div className="d-sm-flex">
                                        <div className="flex-grow-1">
                                            <img src="assets/images/dbclogo.jpg" alt="" height="40" />
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Address</h6>
                                                            <p className="text-muted mb-1" id="address-details">Design Build Cast Ltd
                                                                Unit 3.01,</p>
                                                            <p className="text-muted mb-0">The Goldsmiths Centre,</p>
                                                            <p className="text-muted mb-0">42 Britton Street,
                                                                London EC1M 5AD</p>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mt-sm-5 mt-4">
                                                            <h6 className="text-muted text-uppercase fw-semibold">Review Information</h6>
                                                            {formData.user_close && (
                                                                <>
                                                                    <p className="text-muted mb-0 fs-25" >Reviewed by: {formData.user_close}</p>
                                                                    <p className="text-muted mb-1" id="address-details">{vAdminformat.FormatDate(formData.date_close)}</p>

                                                                    <p className="text-muted mb-0">{formData.comment_close}</p>
                                                                </>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="flex-shrink-0 mt-sm-0 mt-3">
                                            <h6><span className="text-muted fw-normal">Email:</span> <span id="email">enquiries@designbuildcast.co.uk</span></h6>
                                            <h6><span className="text-muted fw-normal">Website:</span> <a href="https://enquiries@designbuildcast.co.uk/" className="link-primary" target="_blank" id="website">designbuildcast.co.uk</a></h6>
                                            <h6 className="mb-0"><span className="text-muted fw-normal">Contact No: </span><span id="contact-no">0207 608 2228
                                            </span></h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body p-4">
                                    <div className="row g-3">
                                        <div className="col-lg-3 col-sm-6">
                                            <label for="invoicenoInput">Order No</label>

                                            <p className="text-muted mb-0 fs-25" >{formData.ord_ID}</p>

                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="date-field">Date</label>

                                                <p className="text-muted mb-0 fs-25" >{vAdminformat.FormatDate(dateCreated)} </p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <div>
                                                <label for="totalamountInput">Total Amount</label>
                                                <p className="text-muted mb-0 fs-25"> {`${vAdminformat.FormatMoney(calculateSubTotal() +
                                                    calculateSubTotal() * 0.20 -
                                                    (calculateSubTotal() * (formData.discount / 100) || 0)
                                                )}`} </p>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-sm-6">
                                            <label htmlFor="choices-payment-status">Status</label>
                                            <div className="input-light">
                                                <select
                                                    className="form-control bg-light border-0"
                                                    id="choices-payment-status"
                                                    required
                                                    value={formData.est_id || formData.est_ID || ''}
                                                    onChange={(e) => setFormData({ ...formData, est_id: e.target.value })}
                                                >
                                                    <option value="">Select Status</option>

                                                    {statusQuot.map((status) => (
                                                        <option key={status.est_ID} value={status.est_ID}>
                                                            {status.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="card-body p-4 border-top border-top-dashed">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-lg-6 col-sm-6">

                                                <div className='mb-3'>
                                                    <label for="billingName" className="text-muted text-uppercase fw-semibold">Customer Information</label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>ID:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.cust_ID}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Full name:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.fullname}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Email:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>{formData.email}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 1:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone}
                                                                        onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Phone 2:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text" className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone"
                                                                        value={formData.phone2}
                                                                        onChange={(e) => setFormData({ ...formData, phone2: e.target.value })}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}


                                            </div>

                                            <div className="col-lg-6 col-sm-6">
                                                <div className='mb-3'>
                                                    <label for="shippingName" className="text-muted text-uppercase fw-semibold">Customer Address
                                                    </label>
                                                </div>
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-10"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-8"></span>
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                        <tbody>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Address:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}><input type="text"
                                                                    className="form-control bg-light border-0"
                                                                    data-plugin="cleave-phone" id="billingPhoneno"

                                                                    value={formData.address}
                                                                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                                                                /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>City:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.city}
                                                                        onChange={(e) => setFormData({ ...formData, city: e.target.value })} /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Country:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"

                                                                        value={formData.country}
                                                                        onChange={(e) => setFormData({ ...formData, country: e.target.value })}
                                                                    /></td>
                                                            </tr>
                                                            <tr>
                                                                <td style={{ padding: '4px 8px' }}><strong>Post Code:</strong></td>
                                                                <td style={{ padding: '4px 8px' }}>
                                                                    <input type="text"
                                                                        className="form-control bg-light border-0"
                                                                        data-plugin="cleave-phone" id="billingPhoneno"
                                                                        value={formData.zipcode}
                                                                        onChange={(e) => setFormData({ ...formData, zipcode: e.target.value })} /></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div className="card-body p-4 justify-content-end">
                                    <div className="table-responsive">
                                        <table className="invoice-table table table-borderless table-nowrap mb-0">
                                            <thead className="align-middle">
                                                <tr className="table-active">
                                                    <th scope="col" style={{ width: "50px" }}>#</th>
                                                    <th scope="col">Image</th>
                                                    <th scope="col">
                                                        Product Details
                                                    </th>
                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <div className="d-flex currency-select input-light align-items-center">
                                                            Material
                                                        </div>
                                                    </th>
                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <div className="d-flex currency-select input-light  text-end justify-content-end">
                                                            Price
                                                        </div>
                                                    </th>

                                                    <th scope="col" style={{ width: "120px" }}>
                                                        <center>Quantity</center></th>
                                                    <th scope="col" style={{ width: "60px" }}>
                                                        <center>Discount</center></th>
                                                    <th scope="col" className="text-end" style={{ width: "150px" }}>Sub Total</th>
                                                    <th scope="col" className="text-end" style={{ width: "105px" }}></th>
                                                </tr>
                                            </thead>
                                            <tbody id="newlink">
                                                {loading ? (
                                                    <div className="col-lg-12 col-sm-12">
                                                        <div aria-hidden="true">
                                                            <div className="table-responsive">
                                                                <table className="table table-borderless">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="placeholder-glow">
                                                                                <span className="placeholder col-12"></span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    formData.jobs && formData.jobs.length > 0 ? (
                                                        formData.jobs.map((item, index) => (
                                                            <tr id={index} className="product" key={index}>
                                                                <th scope="row" className="product-id">{index + 1}</th>
                                                                <td>
                                                                    <div style={{ height: "13vh", width: "13vh" }}>
                                                                        <SimpleSTLViewer url={`${server_backend}/${item.files_path_file}`} />
                                                                    </div>
                                                                </td>
                                                                <td className="text-start">
                                                                    <td className="text-start">
                                                                        <span className="fw-medium">{item.comment}</span>
                                                                        <p className="text-muted mb-0">Uploaded file: {item.file_name}</p>
                                                                        <p className="text-muted mb-0">Dimensions: {item.dimensions}</p>
                                                                        <p className="text-muted mb-0">Volume: {item.volume} cm³ / Area: {item.area}</p>
                                                                        <p className="text-muted mb-0">Weight: {item.weight}</p>
                                                                    </td>
                                                                </td>
                                                                <td>
                                                                    <span className="fw-medium">{item.materials_name}</span>
                                                                    <div className="invalid-feedback">
                                                                        Please enter a rate
                                                                    </div>
                                                                </td>
                                                                {/*Precio */}
                                                                <td >
                                                                    <div className="d-flex currency-select input-light  text-end justify-content-end">
                                                                        <span >{vAdminformat.FormatMoney(item.price)}</span>
                                                                    </div>
                                                                </td>
                                                                {/*Quantity with buttons to increase/decrease */}
                                                                <td>
                                                                    <div className='d-flex justify-content-center'>
                                                                        <span className="fw-medium">{item.qty}</span>
                                                                    </div>
                                                                </td>
                                                                <td className="text-end">
                                                                    <div className="d-flex currency-select input-light  text-end justify-content-end">
                                                                        <span >{vAdminformat.FormatMoney(item.discount)}</span>
                                                                    </div>
                                                                </td>
                                                                {/*Total calculated */}
                                                                <td className="text-end">
                                                                    <div className="d-flex currency-select input-light  text-end justify-content-end">
                                                                        <span >{vAdminformat.FormatMoney(item.price * item.qty)}</span>
                                                                    </div>
                                                                </td>
                                                                {/*Elimination button */}
                                                                <td className="product-removal">
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-outline-primary"
                                                                            type='button'
                                                                            onClick={() => {

                                                                                openModalFile(item, false);
                                                                            }}
                                                                        >
                                                                            <i className="bx bx-edit"></i>
                                                                        </button>
                                                                    </td>
                                                                    <button type="button" className="btn btn-outline-danger" onClick={() => {
                                                                        deleteJob(item.quotj_ID)
                                                                    }}> <i class="bx bx-trash"></i></button>
                                                                </td>
                                                            </tr>
                                                        ))

                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8">No files selected yet.</td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                            <tr id="newForm" style={{ display: "none" }}></tr>
                                            <tr>
                                                <td colspan="9">
                                                    <button type='button' id="add-item" className="btn btn-soft-secondary fw-medium" onClick={() => {
                                                        openModalFile(null, true)
                                                    }
                                                    }><i className="ri-add-fill me-1 align-bottom" ></i> Add Item</button>
                                                </td>
                                            </tr>

                                        </table>
                                    </div>
                                    <div className="border-top border-top-dashed mt-2 d-flex justify-content-end">
                                        <div className="col-auto">
                                            <table className="table table-borderless text-start table-nowrap align-middle mb-0">
                                                <tbody>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">Subtotal </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.subtotal_summary)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">Discount Total </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.discount_summary)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="row" className="p-2 text-muted fs-5">VAT Total </th>
                                                        <td className="p-0 text-end fs-5">{vAdminformat.FormatMoney(formData.taxtotal_summary)}</td>
                                                    </tr>
                                                    <tr className="border-top border-top-dashed">
                                                        <th scope="row" className="p-2 text-muted fs-5">Total</th>
                                                        <td className="p-0 text-end fw-medium fs-5">{vAdminformat.FormatMoney(formData.total_summary)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <br />
                                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">

                                        <Link className='btn btn-danger' style={{ marginRight: "5px" }} onClick={() => {

                                            Swal.fire({
                                                icon: 'warning',
                                                title: 'Alert',
                                                text: "Are you sure you want to discard these changes?",
                                                showCancelButton: true,
                                                confirmButtonText: 'Accept',
                                                cancelButtonText: "Cancel"
                                            }).then(async (result) => {
                                                if (result.isConfirmed) {
                                                    onClose();
                                                }
                                            }
                                            )
                                        }
                                        }>Discard Change</Link>

                                        <button type="button" className="btn btn-primary" onClick={handleUpdate}><i className="ri-save-line align-bottom me-1"></i> Save</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className={`modal fade ${fileUploadList ? 'show' : ''}`} style={{ display: fileUploadList ? 'block' : 'none', backgroundColor: "#0000007a" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="myExtraLargeModalLabel">{isUpdateJob === 1 ? "Update Job" : "Create Job"}</h5>
                                <button type="button" className="btn-close" onClick={closeModalFile} aria-label="Close"></button>
                            </div>
                            <div className="modal-body" style={{ minHeight: "80vh" }}>
                                <div id="paymentAccordion">
                                    {isUpdateJob === 0 && (
                                        <div className="row">
                                            <div className="col-lg-4 col-sm-6">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod01"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseCustomerFile"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseCustomerFile"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setIsPrivate(0)
                                                            setSelectedFiles([]);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod01">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                        <span className="fs-15 text-wrap"> All Files</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod02"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseMyLibrary"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseMyLibrary"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setSelectedFiles([]);
                                                            setIsPrivate(1);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod02">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-user-fill"></i></span>
                                                        <span className="fs-15 text-wrap">Print Folder</span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-lg-4 col-md-6 col-sm-12">
                                                <div className="form-check card-radio">
                                                    <input
                                                        id="paymentMethod03"
                                                        name="paymentMethod"
                                                        type="radio"
                                                        className="form-check-input"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#paymentmethodCollapseUploadFile"
                                                        aria-expanded="false"
                                                        aria-controls="paymentmethodCollapseUploadFile"
                                                        onClick={() => {
                                                            setSTLFileBussiness(null);
                                                            setConfUpload(false);
                                                            setSelectedFiles([]);
                                                            setFormData({
                                                                ...formData,
                                                                volume: "",
                                                                area: "",
                                                                weight: "",
                                                                file_id: "",
                                                                dimensions: ""
                                                            });
                                                        }}
                                                    />
                                                    <label className="form-check-label" htmlFor="paymentMethod03">
                                                        <span className="fs-16 text-muted me-2"><i className="ri-upload-2-line"></i></span>
                                                        <span className="fs-15 text-wrap">Upload File</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="collapse show" id="paymentmethodCollapseCustomerFile" data-bs-parent="#paymentAccordion">
                                        <div style={{ marginBlock: "1em" }}>
                                            {isUpdateJob === 0 ? (
                                                <div className="mb-3">
                                                    <label htmlFor="select-existing-customer" className="form-label">My Library</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        id="select-existing-customer"
                                                        placeholder="Select or search for a File..."
                                                        onFocus={() => setIsDropdownVisible(true)}
                                                    />

                                                    {isDropdownVisible && (
                                                        <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                            {customerFiles && customerFiles.length > 0 ? (
                                                                customerFiles.map((CustomerFile) => (
                                                                    <button className="dropdown-item" type="button" key={CustomerFile.id || CustomerFile.name} onClick={() => {
                                                                        handleFileSelect(CustomerFile);
                                                                        setFileURL(`${server_backend}/${CustomerFile.path_file}`)
                                                                    }
                                                                    }>
                                                                        {CustomerFile.name}
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No File found
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            ) : null}

                                            <div className="row">

                                                <div className="col-lg-6 col-md-12">
                                                    <div className="row">
                                                        {(STLfileBussiness && STLfileBussiness.name) && (
                                                            <div className="mt-3">
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                                <div>
                                                                    <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} isUpdateJob={isUpdateJob} nanito={nanito} setNanito={setNanito} />
                                                                </div>
                                                                <div className="col-12 mb-3">
                                                                    <div className="row mt-3">
                                                                        {/*Estimated Completion Date Field */}
                                                                        <div className="col-6 d-flex flex-column">
                                                                            <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                                            <input
                                                                                type="datetime-local"
                                                                                className="form-control text-center"
                                                                                id="estimatedCompletionInput"
                                                                                value={formData.date_estimated}
                                                                                onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                                                            />
                                                                        </div>

                                                                        {/*Parts Field */}
                                                                        <div className="col-6 d-flex flex-column">
                                                                            <label htmlFor="partsInput" className="form-label">Parts</label>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                id="partsInput"
                                                                                value={parseInt(formData.parts)}
                                                                                onChange={(e) => setFormData({ ...formData, parts: e.target.value })}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}


                                                    </div>
                                                </div>

                                                <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                            </center>
                                                            <div
                                                                style={{
                                                                    minHeight: '26vh',
                                                                    height: '26vh',
                                                                    border: '1px solid #dcdcdc',
                                                                    padding: "20px",
                                                                    width: "100%",
                                                                    backgroundColor: "#fff",
                                                                    overflowY: 'auto',
                                                                }}
                                                            >
                                                                {materialList && materialList.length > 0 ? (
                                                                    materialList.map((material) => (
                                                                        <button
                                                                            key={material.mat_ID}
                                                                            className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                            type="button"
                                                                            onClick={() => {
                                                                                console.log(nanito);
                                                                                const vw = formData.weight * material.density;
                                                                                handleMaterialSelect(material);

                                                                                setSelectedMaterialColor(material.color);
                                                                                setCurrentDencity(material.density);

                                                                                const price = calculatePrice(material.formula, vw, materialPrice);
                                                                                //console.log({ vw: vw, materialPrice: price });
                                                                                setCurrentPrice(price);
                                                                            }}
                                                                        >
                                                                            <div className="d-flex align-items-center">
                                                                                <ColorBox color={material.color} />
                                                                                <span className="ms-2">{material.name}</span>
                                                                            </div>
                                                                        </button>
                                                                    ))
                                                                ) : (
                                                                    <button className="dropdown-item" type="button" disabled>
                                                                        No materials found
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <center>
                                                                <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                            </center>
                                                            <div className="table-responsive" style={{ width: '100%', height: '40vh', overflow: "hidden" }}>
                                                                <table className="table table-bordered" style={{ width: '100%', height: '100%' }}>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="priceInput"
                                                                                    value={formData.volume}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, volume: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="priceInput"
                                                                                    value={formData.area}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, area: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold"><h6>Weight:</h6></td>
                                                                            <td className="text-end" style={{ width: "20%" }}>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control text-center small-input"
                                                                                    id="priceInput"
                                                                                    value={formData.weight}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, weight: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td className="font-weight-bold"><h6>Dimension:</h6></td>
                                                                            <td className="text-end">
                                                                                <input
                                                                                    type="text"
                                                                                    className="form-control text-center small-input"
                                                                                    id="priceInput"
                                                                                    value={formData.dimensions}
                                                                                    onChange={(e) => {
                                                                                        setFormData({ ...formData, dimensions: e.target.value });
                                                                                    }}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>

                                                                </table>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="collapse" id="paymentmethodCollapseMyLibrary" data-bs-parent="#paymentAccordion">
                                        <div style={{ marginBlock: "1em" }}>
                                            <div className="mb-3">
                                                <label htmlFor="select-existing-customer" className="form-label">Print Folder</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="select-existing-customer"
                                                    placeholder="Select or search for a File..."
                                                    onFocus={() => setIsDropdownVisible(true)}
                                                />

                                                {isDropdownVisible && (
                                                    <div className="dropdown-menu show w-100" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                        {getBussinessFiles && getBussinessFiles.length > 0 ? (
                                                            getBussinessFiles.map((bussinessFile) => (
                                                                <button className="dropdown-item" type="button" key={bussinessFile.id || bussinessFile.name} onClick={() => {
                                                                    handleFileSelect(bussinessFile);
                                                                    setFileURL(`${server_backend}/${bussinessFile.path_file}`)
                                                                }
                                                                }>
                                                                    {bussinessFile.name}
                                                                </button>
                                                            ))
                                                        ) : (
                                                            <button className="dropdown-item" type="button" disabled>
                                                                No File found
                                                            </button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="row">

                                                <div className="col-lg-6 col-md-12">
                                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                                        <div className="mt-3">
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Selected File: {STLfileBussiness.name}</p>
                                                            <div>
                                                                <STLViewerQuot url={fileURL} currentColor={selectedMaterialColor} onStatsUpdate={handleStatsUpdate} data={formData} currentDencity={currentDencity} isUpdateJob={isUpdateJob} nanito={nanito} setNanito={setNanito} />
                                                            </div>
                                                            <div className="col-12 mb-3">
                                                                <div className="row mt-3">
                                                                    {/*Estimated Completion Date Field */}
                                                                    <div className="col-6 d-flex flex-column">
                                                                        <label htmlFor="estimatedCompletionInput" className="form-label">Estimated Completion Date</label>
                                                                        <input
                                                                            type="datetime-local"
                                                                            className="form-control text-center"
                                                                            id="estimatedCompletionInput"
                                                                            value={formData.date_estimated ? formData.date_estimated : formData.date_estimated}
                                                                            onChange={(e) => setFormData({ ...formData, date_estimated: e.target.value })}
                                                                        />
                                                                    </div>


                                                                    {/*Parts Field */}
                                                                    <div className="col-6 d-flex flex-column">
                                                                        <label htmlFor="partsInput" className="form-label">Parts</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control text-center"
                                                                            id="partsInput"
                                                                            value={parseInt(formData.parts)}
                                                                            onChange={(e) => setFormData({ ...formData, parts: e.target.value })}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="col-lg-6 col-md-12">
                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Material</p>
                                                        </center>
                                                        <div
                                                            style={{
                                                                minHeight: '23vh',
                                                                height: '22vh',
                                                                border: '1px solid #dcdcdc',
                                                                padding: "20px",
                                                                width: "100%",
                                                                backgroundColor: "#fff",
                                                                overflowY: 'auto',
                                                            }}
                                                        >
                                                            {materialList && materialList.length > 0 ? (
                                                                materialList.map((material) => (
                                                                    <button
                                                                        key={material.mat_ID}
                                                                        className={`dropdown-item d-flex align-items-center justify-content-between ${selectedMaterial?.mat_ID === material.mat_ID ? 'bg-primary text-white' : ''}`}
                                                                        type="button"
                                                                        onClick={() => {

                                                                            handleMaterialSelect(material);
                                                                            setSelectedMaterialColor(material.color);
                                                                            setCurrentDencity(material.density);


                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center">
                                                                            <ColorBox color={material.color} />
                                                                            <span className="ms-2">{material.name}</span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            ) : (
                                                                <button className="dropdown-item" type="button" disabled>
                                                                    No materials found
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}

                                                {(STLfileBussiness && STLfileBussiness.name) && (
                                                    <div className="mt-3">
                                                        <center>
                                                            <p style={{ marginBottom: "10px", fontWeight: "bold", fontSize: "16px" }}>Model Stats:</p>
                                                        </center>
                                                        <div className="table-responsive" style={{ width: '100%', height: '42vh', overflow: "hidden" }}>
                                                            <table className="table table-bordered" style={{ width: '100%', height: '100%' }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Volume:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.volume}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, volume: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Area:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.area}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, area: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Weight:</h6></td>
                                                                        <td className="text-end" style={{ width: "20%" }}>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.weight}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, weight: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="font-weight-bold"><h6>Dimension:</h6></td>
                                                                        <td className="text-end">
                                                                            <input
                                                                                type="text"
                                                                                className="form-control text-center small-input"
                                                                                id="priceInput"
                                                                                value={formData.dimensions}
                                                                                onChange={(e) => {
                                                                                    setFormData({ ...formData, dimensions: e.target.value });
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                )}
                                                </div>

                                            </div>


                                        </div>
                                    </div>

                                    <div className="collapse" id="paymentmethodCollapseUploadFile" data-bs-parent="#paymentAccordion">

                                        {ConfUpload ? (
                                            <div class="alert alert-success alert-dismissible fade show" style={{ marginBlock: "2em" }} role="alert">
                                                <strong>File uploaded successfully!</strong> You can find the file in "My Library" with the same name.
                                                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                            </div>

                                        ) : (
                                            <div style={{ marginBlock: "2em" }}>
                                                <div >
                                                    <label htmlFor="formFile" className="form-label">Upload Your File</label>
                                                    <input className="form-control" type="file" id="formFile" accept=".stl" onChange={handleFileChange} />
                                                </div>

                                                {selectedFiles.length > 0 && (
                                                    <div className="mt-3">
                                                        <h6>Selected Files:</h6>
                                                        <ul className="list-group">
                                                            {selectedFiles.map((file, index) => (
                                                                <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                                    {file.name}
                                                                    <span className="badge bg-primary rounded-pill">{Math.round(file.size / 1024)} KB</span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}

                                                {isUploading && (
                                                    <div className="progress mt-3">
                                                        <div
                                                            className="progress-bar progress-bar-striped progress-bar-animated"
                                                            role="progressbar"
                                                            aria-valuenow={uploadProgress}
                                                            aria-valuemin="0"
                                                            aria-valuemax="100"
                                                            style={{ width: `${uploadProgress}%` }}
                                                        >
                                                            {uploadProgress}%
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="mt-3">
                                                    <button className="btn btn-primary w-100" onClick={handleUploadFileModal} disabled={isUploading}>
                                                        {isUploading ? 'Uploading...' : 'Upload and Save'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="row">
                                            {/*Quantity Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="quantityInput" className="form-label">Quantity</label>
                                                <div className="input-step d-flex align-items-center w-100">
                                                    <button type="button" className="minus btn btn-light" onClick={() => handleDecreaseQuantity()}>–</button>
                                                    <input
                                                        type="number"
                                                        className="form-control text-center mx-2 product-quantity w-100"
                                                        value={formData.qty ? formData.qty : 1}
                                                        min="0"
                                                        max="100"
                                                        readOnly
                                                    />
                                                    <button type="button" className="plus btn btn-light" onClick={() => handleIncreaseQuantity()}>+</button>
                                                </div>
                                            </div>

                                            {/*Price Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="priceInput" className="form-label">Price</label>
                                                <input
                                                    type="number"
                                                    className="form-control text-center bg-light "
                                                    id="priceInput"
                                                    value={currentPrice}
                                                    onChange={handlePriceChange}
                                                />
                                            </div>

                                            {/*Discount */}

                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="priceInput" className="form-label">Discount</label>
                                                <div className="input-group">
                                                    <input
                                                        type="number"
                                                        className="form-control bg-light"
                                                        id="cart-discount"
                                                        value={formData.discount}
                                                        onChange={(e) => {

                                                            let value = 0;
                                                            if (e.target.value == '') {
                                                                value = 0;
                                                                e.target.value = 0;
                                                                setFormData({ ...formData, discount: value });
                                                            } else {
                                                                e.target.value = parseInt(e.target.value);
                                                                setFormData({ ...formData, discount: parseInt(e.target.value) });
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {/*Total Field */}
                                            <div className="col-3 d-flex flex-column">
                                                <label htmlFor="totalInput" className="form-label">Total</label>
                                                <input
                                                    type="text"
                                                    className="form-control text-center bg-light"
                                                    id="totalInput"
                                                    value={vAdminformat.FormatMoney(
                                                        (currentPrice * formData.qty) - (formData.discount || 0)
                                                    )}
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="row mt-3">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label htmlFor="jobComment">Description:</label>
                                                    <textarea
                                                        id="jobComment"
                                                        className="form-control"
                                                        value={formData.job_comment}
                                                        onChange={(e) => setFormData({ ...formData, job_comment: e.target.value })}
                                                        placeholder="Add your comments here"
                                                        rows="5"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(STLfileBussiness && STLfileBussiness.name) && (
                                        <div className="col-12">
                                            <div className="card border-light shadow-sm mb-3" style={{ marginBlock: "10px", border: '1px solid #dcdcdc' }}>
                                                <div className="card-body d-flex justify-content-end align-items-center flex-wrap">

                                                    {isUpdateJob === 0 ? (<button
                                                        className="btn btn-primary w-25"
                                                        onClick={createJobs}
                                                    >
                                                        Save
                                                    </button>) : (<button
                                                        className="btn btn-primary w-25"
                                                        onClick={UpdateFileToItems}
                                                    >
                                                        Save
                                                    </button>)}

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}

export default UpdateOrder;
